import { FC } from 'react'
import FacebookSvg from '@/public/images/social_icons/facebook-gray_v2.svg'
import TwitterSvg from '@/public/images/social_icons/twitter-gray_v2.svg'
import InstagramSvg from '@/public/images/social_icons/instagram-gray_v2.svg'
import LinkedInSvg from '@/public/images/social_icons/linkedin-gray_v2.svg'
import GitHubSvg from '@/public/images/social_icons/github-gray_v2.svg'
import { SocialIconLink } from '@components-v2/atoms/SocialIconLink'
import styles from './index.module.scss'

type Props = {
  twitterUrl: string
  facebookUrl: string
  instagramUrl: string
  linkedInUrl: string
  githubUrl?: string
}

export const ProfileSocialMedialLinks: FC<Props> = ({
  twitterUrl,
  facebookUrl,
  instagramUrl,
  linkedInUrl,
  githubUrl = '',
}) => {
  return (
    <div className={styles.container}>
      {twitterUrl && <SocialIconLink href={twitterUrl} iconNode={<TwitterSvg viewBox='0 0 24 24' />} />}
      {facebookUrl && <SocialIconLink href={facebookUrl} iconNode={<FacebookSvg viewBox='0 0 24 24' />} />}
      {instagramUrl && <SocialIconLink href={instagramUrl} iconNode={<InstagramSvg viewBox='0 0 24 24' />} />}
      {linkedInUrl && <SocialIconLink href={linkedInUrl} iconNode={<LinkedInSvg viewBox='0 0 24 24' />} />}
      {githubUrl && <SocialIconLink href={githubUrl} iconNode={<GitHubSvg viewBox='0 0 24 24' />} />}
    </div>
  )
}
